var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchMagnifyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.0356L15.514 14.0231M18 8.66058C18 10.6734 17.1045 12.6037 15.5104 14.027C13.9163 15.4503 11.7543 16.2499 9.5 16.2499C7.24566 16.2499 5.08365 15.4503 3.48959 14.027C1.89553 12.6037 1 10.6734 1 8.66058C1 6.64777 1.89553 4.71741 3.48959 3.29414C5.08365 1.87087 7.24566 1.07129 9.5 1.07129C11.7543 1.07129 13.9163 1.87087 15.5104 3.29414C17.1045 4.71741 18 6.64777 18 8.66058Z",
    stroke: "#5E639B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchMagnifyIcon);
export default __webpack_public_path__ + "static/media/SearchMagnifyIcon.3cb3c2e68bbdc964a67d1e2076458cfa.svg";
export { ForwardRef as ReactComponent };